import { Box, Button, Card, CardContent, IconButton, Modal, Typography } from "@mui/material";
import React from "react";
import { TutorialBody, TutorialContainer, TutorialContent } from "./styles";
import { Layout } from "../SharedComponents/Layout";
import { PictureAsPdf, Visibility, Close } from "@mui/icons-material";
import { SearchInput } from "../SharedComponents/SearchInput";

type TutorialData = {
  id: number;
  name: string;
  pdfPath: string;
};

const boxStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 1200,
  height: "90%",
  bgcolor: "background.paper",
  borderRadius: 4,
  boxShadow: 24,
  p: 4,
};

const tutorialsData: TutorialData[] = [
  {
    id: 1,
    name: "Como se cadastrar na plataforma CATvante?",
    pdfPath: "/tutorials/1-como-se-cadastrar.pdf",
  },
  {
    id: 2,
    name: "Como adquirir uma licença de um instrumento?",
    pdfPath: "/tutorials/2-como-adquirir-uma-licenca.pdf",
  },
  {
    id: 3,
    name: "Como criar uma aplicação de instrumento?",
    pdfPath: "/tutorials/3-como-criar-uma-aplicacao.pdf",
  },
  {
    id: 4,
    name: "Como convidar um novo usuário respondente e enviar uma aplicação de instrumento?",
    pdfPath: "/tutorials/4-como-convidar-novo-usuario.pdf",
  },
  {
    id: 5,
    name: "Como um respondente novo acessa a aplicação do instrumento?",
    pdfPath: "/tutorials/5-como-um-respondente-acessa-aplicacao.pdf",
  },
  {
    id: 6,
    name: "Como acessar o relatório de devolutiva individual?",
    pdfPath: "/tutorials/6-como-acessar-devolutiva-individual.pdf",
  },
  {
    id: 7,
    name: "Como acessar o relatório de devolutiva agregada?",
    pdfPath: "/tutorials/7-como-acessar-devolutiva-agregada.pdf",
  },
  {
    id: 8,
    name: "Como enviar uma aplicação para um respondente cadastrado?",
    pdfPath: "/tutorials/8-como-enviar-aplicacao-para-respondente-cadastrado.pdf",
  },
  {
    id: 9,
    name: "Como enviar uma aplicação para um respondente por meio de link?",
    pdfPath: "/tutorials/9-como-enviar-aplicacao-para-respondente-por-link.pdf",
  },
  {
    id: 10,
    name: "Como fazer o pagamento das licenças de instrumentos por cartão de crédito?",
    pdfPath: "/tutorials/10-como-fazer-pagamento-cartao.pdf",
  },
  {
    id: 11,
    name: "Como fazer o pagamento das licenças de instrumentos por PIX?",
    pdfPath: "/tutorials/11-como-fazer-pagamento-pix.pdf",
  },
  {
    id: 12,
    name: "Como um respondente cadastrado acessa a aplicação do instrumento?",
    pdfPath: "/tutorials/12-como-respondente-cadastrado-acessa-aplicacao.pdf",
  },
  {
    id: 13,
    name: "Como acessar o manual do instrumento?",
    pdfPath: "/tutorials/13-como-acessar-manual-do-instrumento.pdf",
  },
  {
    id: 14,
    name: "Como recuperar a sua senha?",
    pdfPath: "/tutorials/14-como-recuperar-senha.pdf",
  },
  {
    id: 15,
    name: "Como recuperar uma licença de uma aplicação acessada por link anônimo/identificado e que ainda não foi concluída?",
    pdfPath: "/tutorials/15-recuperar-licenca-acessada-anonima-ou-identificada-nao-concluida.pdf",
  },
  {
    id: 16,
    name: "Como recuperar uma licença de uma aplicação de respondente individual e que ainda não foi concluída?",
    pdfPath: "/tutorials/16-recuperar-licenca-aplicacao-respondente-individual-nao-concluida.pdf",
  },
];

export default function Tutorials() {
  const [filteredTutorials, setFilteredTutorials] = React.useState<TutorialData[]>(tutorialsData);
  const [searchFilter, setSearchFilter] = React.useState<string>("");
  const [openModal, setOpenModal] = React.useState<boolean>(false);
  const [selectedTutorial, setSelectedTutorial] = React.useState<TutorialData | null>(null);

  const handleSearch = React.useCallback(() => {
    if (searchFilter.trim() === "") {
      setFilteredTutorials(tutorialsData);
    } else {
      const filtered = tutorialsData.filter((tutorial) =>
        tutorial.name.toLowerCase().includes(searchFilter.toLowerCase())
      );
      setFilteredTutorials(filtered);
    }
  }, [searchFilter]);

  const handleOpenPdfReader = (tutorial: TutorialData) => {
    // Detecta se é mobile
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth < 768;

    if (isMobile) {
      // Em mobile, abre diretamente em nova aba
      window.open(tutorial.pdfPath, '_blank');
    } else {
      // Em desktop, abre o modal
      setSelectedTutorial(tutorial);
      setOpenModal(true);
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedTutorial(null);
  };

  return (
    <TutorialContainer>
      <Layout>
        {/* <Header logoutEnabled={true} /> */}
        {/* <Header2 /> */}

        <TutorialBody>
          <TutorialContent>
            <Box
              display={"flex"}
              justifyContent={"space-between"}
              alignItems={"center"}
              marginBottom={3}
              width={"100%"}
              flexWrap="wrap"
            >
              <Typography variant="h2">
                Tutoriais
              </Typography>
              <SearchInput
                label="Pesquisar Tutoriais"
                onSearch={handleSearch}
                onChangeFilter={setSearchFilter}
              />
            </Box>

            {/* Listagem de Tutoriais */}
            <Box display="flex" flexDirection="column" gap={2} marginBottom={3} width="100%">
              {filteredTutorials.map((tutorial) => (
                <Card
                  key={tutorial.id}
                  sx={{
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      borderColor: "#1EA097",
                      transform: "translateY(-1px)",
                    },
                    border: "1px solid #e0e0e0",
                    boxShadow: "none",
                    borderRadius: 2,
                  }}
                  onClick={() => handleOpenPdfReader(tutorial)}
                >
                  <CardContent sx={{ padding: 2 }}>
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      width="100%"
                      gap={2}
                      sx={{
                        flexDirection: {
                          xs: "column",
                          sm: "row",
                        },
                      }}
                    >
                      <Box display="flex" alignItems="center" gap={2} flex={1}>
                        <Typography
                          variant="h6"
                          fontWeight="bold"
                          color="#1EA097"
                          sx={{
                            textAlign: "center",
                            backgroundColor: "#f5f5f5",
                            padding: "0.5rem 1.25rem",
                            borderRadius: "8px",
                            fontSize: "1.1rem",
                          }}
                        >
                          {tutorial.id}
                        </Typography>

                        <Typography
                          variant="h6"
                          fontWeight="medium"
                          color="text.primary"
                          sx={{
                            flex: 1,
                            fontSize: "1.1rem",
                          }}
                        >
                          {tutorial.name}
                        </Typography>
                      </Box>

                      <Box
                        onClick={(e) => {
                          e.stopPropagation();
                          handleOpenPdfReader(tutorial);
                        }}
                        sx={{ display: "flex", alignItems: "center" }}
                      >
                        {/* Botão responsivo */}
                        <Button
                          variant="contained"
                          sx={{
                            backgroundColor: "#1EA097",
                            color: "white",
                            "&:hover": {
                              backgroundColor: "#158B82",
                            },
                            display: {
                              xs: "flex",
                              sm: "none",
                            },
                            minWidth: "auto",
                            padding: "8px 16px",
                          }}
                        >
                          <Visibility sx={{ marginRight: 1, fontSize: 20 }} />
                            Ver PDF
                        </Button>

                        {/* Ícone apenas para telas maiores */}
                        <IconButton
                          sx={{
                            backgroundColor: "#1EA097",
                            color: "white",
                            "&:hover": {
                              backgroundColor: "#158B82",
                            },
                            display: {
                              xs: "none",
                              sm: "flex",
                            },
                          }}
                        >
                          <Visibility />
                        </IconButton>
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              ))}
            </Box>

            {/* Mensagem quando não há resultados */}
            {filteredTutorials.length === 0 && (
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                padding={4}
                textAlign="center"
              >
                <PictureAsPdf sx={{ fontSize: 64, color: "#ccc", marginBottom: 2 }} />
                <Typography variant="h6" color="textSecondary" marginBottom={1}>
                  Nenhum tutorial encontrado
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Tente ajustar sua busca ou verifique se o nome está correto.
                </Typography>
              </Box>
            )}
          </TutorialContent>
        </TutorialBody>
      </Layout>

      {/* Modal com Leitor PDF */}
      <Modal open={openModal} onClose={handleCloseModal}>
        <Box sx={boxStyle}>
          <Box display="flex" flexDirection="column" height="100%">
            {/* Header do Modal */}
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              marginBottom={2}
              paddingBottom={2}
              borderBottom="1px solid #e0e0e0"
            >
              <Typography variant="h5" color={"#1EA097"} fontWeight="medium">
                {selectedTutorial?.name}
              </Typography>

              <Button
                onClick={handleCloseModal}
                color="error"
                sx={{
                  minWidth: "auto",
                  padding: "0.5rem 0.75rem",

                }}
              >
                <Close />
              </Button>
            </Box>

            {/* Leitor PDF */}
            <Box
              flex={1}
              display="flex"
              justifyContent="center"
              alignItems="center"
              border="1px solid #e0e0e0"
              borderRadius={2}
              overflow="hidden"
            >
              {selectedTutorial?.pdfPath ? (
                <iframe
                  src={`${selectedTutorial.pdfPath}#navpanes=0&view=FitH&toolbar=1&scrollbar=1`}
                  width="100%"
                  height="100%"
                  style={{ border: "none" }}
                  title={selectedTutorial.name}
                />
              ) : (
                <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
                  <PictureAsPdf sx={{ fontSize: 64, color: "#ccc" }} />
                  <Typography variant="h6" color="textSecondary">
                    PDF não disponível
                  </Typography>
                </Box>
              )}
            </Box>

            {/* Footer com ações */}
            <Box
              display="flex"
              justifyContent="flex-end"
              gap={2}
              marginTop={2}
              paddingTop={2}
              borderTop="1px solid #e0e0e0"
            >
              <Button
                variant="contained"
                onClick={() => {
                  if (selectedTutorial?.pdfPath) {
                    window.open(selectedTutorial.pdfPath, "_blank");
                  }
                }}
                disabled={!selectedTutorial?.pdfPath}
              >
                Abrir em Nova Aba
              </Button>

              <Button variant="outlined" onClick={handleCloseModal} color="error">
                Fechar
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </TutorialContainer>
  );
}
